import React from 'react';
import NewArticle from './NewArticle';

const EditArticle = ({ organizations, articleID, currentUser }) => {
	return (
		<div>
			<NewArticle
				organizations={organizations}
				articleID={articleID}
				currentUser={currentUser}
			/>
		</div>
	);
};

export default EditArticle;
